<p-messages key="info"></p-messages>
<p-toast key="toast" position="top-center" [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card" *ngIf='displayState.workingDiv'>
    <div class="card-body">
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>

<div class="card bg-light" style="margin-top: 5px;">
    <div class="card-body"style="margin-bottom: 3px;">
        <div class="row">
            <div class="col-md-12 bold" style="text-align: center;"><h4>Value At Risk Report For Open Cases</h4></div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-3"><h5 style="font-weight: bold">Selection Variables</h5>  </div>
            <!--<div class="col-md-7 alert-danger">Enter dates in format dd/mm/yyyy, e.g. 09/15/2014</div>-->
        </div>
        <br />
        <div class="row">
            <div class="col-md-10">
                <table class="table">
                    <tr>
                        <td class="bold">From Date Recvd</td>
                        <td><p-calendar [disabledDays]="[0,6]" [(ngModel)]="myFilter.fromDate" dateFormat="mm/dd/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2050" ></p-calendar></td>
                        <td>&nbsp;</td>
                        <td class="bold">Thru Date Recvd</td>
                        <td><p-calendar [disabledDays]="[0,6]" [(ngModel)]="myFilter.thruDate" dateFormat="mm/dd/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2050" ></p-calendar></td>
                    </tr>
                    <tr>
                        <td class="bold">From Tax Rate Area</td>
                        <td><input type="text" [(ngModel)] = "myFilter.fromTaxRateArea" /></td>
                        <td>&nbsp;</td>
                        <td class="bold">Thru Tax Rate Area</td>
                        <td><input type="text"  [(ngModel)] = "myFilter.thruTaxRateArea" /></td>
                    </tr>
                    <tr>
                        <td class="bold">From Differential Amount</td>
                        <td><input type="text" [(ngModel)] = "myFilter.fromDiffValue" /></td>
                        <td>&nbsp;</td>
                        <td class="bold">Thru Differential Amount</td>
                        <td><input type="text"  [(ngModel)] = "myFilter.thruDiffValue" /></td>
                    </tr>
                    <tr>
                      <td class="bold">Sort List By</td>
                      <td>
                        <select [(ngModel)]="myFilter.sortBy">
                          <option></option>
                          <option *ngFor="let sortBy of sortByList" value="{{sortBy.id}}">{{sortBy.desc}}</option>
                        </select>
                      </td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="2"></td>
                        <td><button class="btn btn-warning" title="Clicking this button will clear all values entered in the above form" (click)="resetFilters()" style="margin-right: 10px;">Clear Filters</button> </td>
                        <td colspan="2"><button class="btn btn-success" title="Clicking this button will generate a report based on the above specified criteria" (click)="runValueAtRiskReport()" [disabled]="needVariables()">Run Value At Risk Report</button></td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>
